import React, { useState, useEffect } from 'react';

import styles from './Footer.scss';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const [lng, setLng] = useState(i18n.language);
  const [cookies, setCookie] = useCookies(['lng']);
  useEffect(() => {
    i18n.changeLanguage(lng);
    setCookie('lng', lng, {path: '/', sameSite: 'strict'});
  }, [lng]);

  const setLanguage = () => {
    const data = document.getElementById("selectLanguage").value;
    setLng(data);
  }

  return (
    <div className={styles.container}>
      <div className={styles.Links}>
        {/* <a href="https://payrollth.jobcan.in.th" rel="noopener noreferrer" target="_blank">
          {t('components.Footer.Footer.About_JOBCAN_Payroll')}
        </a>
        <a href="https://jobcan-payroll.zendesk.com/hc/ja" rel="noopener noreferrer" target="_blank">
          {t('components.Footer.Footer.Help')}
        </a>
        <a href="https://payrollth.jobcan.in.th/terms" rel="noopener noreferrer" target="_blank">
          {t('components.Footer.Footer.Terms_of_Use')}
        </a>
        <a href="https://jobcan.ne.jp/privacypolicy" rel="noopener noreferrer" target="_blank">
          {t('components.Footer.Footer.Privacy_Policy')}
        </a>
        <a href="https://payrollth.jobcan.in.th/privacy" rel="noopener noreferrer" target="_blank">
          {t('components.Footer.Footer.Handling_of_Personal_Information')}
        </a> */}
      </div>
      <div className={styles.SelectBox}>
        <select id="selectLanguage" onChange={setLanguage}>
          <option value="">Select language</option>
          <option value="ja">Japanese</option>
          <option value="en">English</option>
          <option value="th">Thai</option>
          <option value="vi">Vietnamese</option>
        </select>
      </div>
      <div className={styles.CopyRight}>Copyright &copy; Donuts. All Rights Reserved.</div>
    </div>
  );
};

export default Footer;
